import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class UnidadeMedidaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        
        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.idcategoriaerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if (!validated) {
            this.showMessage(new Message("alert", 'msg-erro-campo-descricao-obrigatorio', true));
        }

        return validated;
    }
}